<template>
  <div style="background-color: #000000">
    <myheader
      :backFlag="true"
      :backIntercept="true"
      @childBackEvent="back"
      headTitle="扫一扫"
    ></myheader>
    <div id="scancode" class="scancode all_text_center"></div>
  </div>
</template>

<script>
import {
  Dialog
} from 'vant';
import {
  realLiveAuth,
  initIosAuth
} from '../../utils/nativeRealLiveAuth.js';
import {
  getSealHashSign
} from '../../utils/nativeCertSign.js';
import {
  closeCurrentPage
} from '../../utils/nativeOtherOperate.js';
import {
  setEssToken
} from "../../utils/cookies.js";
export default {
  data() {
    return {
      //实人，活体认证,扫码签requestId,
      requestId: '',
      //扫码签appCode,
      appCode: '',
      //扫码签token,
      token: '',
      //token
      verifyToken: '',
      //
      clickId: '',
      //
      retryIndex: 0,
      //
      retryCount: 0,
      //
      index: 0,
    }
  },
  methods: {
    //
    back() {
      closeCurrentPage(0)
    },
    //
    init() {
      let result = this.$route.query.scanCode
      if (result.search('af-') != -1 || result.search('lf-') != -1 ||
        result.search('ss-') != -1 || result.search('MOCK-') != -1) {
        //请求接口
        //从result中获取要执行操作的类型和其他信息（requestid或登录，或盖章hash）
        this.getResultType(result)
      } else {
        this.$Toast('不支持当前二维码！');
        setTimeout(() => {
          closeCurrentPage(0)
        }, 1000)
      }
      //ios版每次使用前需要初始化
      initIosAuth()
    },
    //根据扫码返回数据获取任务类型和数据
    getResultType(requestId) {
      let type = requestId.substr(0, 3)
      switch (type) {
        case 'MOC':
        //实人认证
        case 'af-':
        //活体认证
        case 'lf-':
          //调用实人认证或活体认证
          this.$store.dispatch(this.$LoadShow, true)
          realLiveAuth({
            type: '3',
            requestId: requestId
          })
          //this.getCerifyIdForRequestId(requestId)
          break;
        //扫码签
        case 'ss-':
          this.parseData(requestId)
          break;
        //扫码跳转合同存证报告
        default:
          this.$Toast('不支持当前二维码！');
          setTimeout(() => {
            closeCurrentPage(0)
          }, 1000)
          break;
      }
    },
    //获取esstoken
    getEssToken() {
      document.cookie = ''
      this.$store.dispatch(this.$LoadShow, true)
      this.$get('/seal/api/genAppToken', {
        appCode: this.appCode
      }).then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success && res.data) {
          this.token = res.data
          //this.appCode = res.data.appCode
          //this.requestId = requestId
          this.clickId = this.Tool.generateUUID()
          this.getQrNextArgsForRequestId()
        } else {
          this.$Toast(res.message || '获取token失败，请重试!')
        }
      }).catch((err) => {
        console.log('catch--=', err)
        this.$store.dispatch(this.$LoadShow, false)
        this.$Toast('获取token失败，请重试!')
      });
    },
    //解析扫码签data获取requestId和verifyToken
    parseData(codeData) {
      let temp = codeData.split('||')
      if (temp && Array.isArray(temp) && temp.length > 1) {
        this.requestId = temp[0]
        this.appCode = temp[1]
        //this.verifyToken = temp[2]
        this.getEssToken()
        //this.getQrNextArgsForRequestId()
      } else {
        this.$message.error('获取数据失败，请重试！')
      }
    },
    //扫码签根据requestId获取盖章数据
    getQrNextArgsForRequestId(data) {
      this.$store.dispatch(this.$LoadShow, true)
      this.$sealp('/api/doc/sign/qr/nextArgs?token=' + this.token,
        JSON.stringify({
          requestId: this.requestId,
          lockId: data ? data.lockId : '',
          fileId: data ? data.fileId : ''
        }), this.appCode)
        .then(res => {
          if (res.success) {
            if (res.data) {
              if (data) {
                res.data.lockId = data.lockId
                res.data.fileId = data.fileId
              }
              if (!this.verifyToken) {
                this.verifyToken = res.data.token
              }
              this.getSignFileHash(res.data)
            } else {
              this.signResultToast('完成盖章!', false)
              //this.completeSign()
            }
          } else {
            this.signResultToast(res.message)
          }
        }).catch(err => {
          console.log('catch--=', err)
          this.signResultToast(res.message)
        })
    },
    //扫码签盖章流程错误流程
    signResultToast(message, flag = true) {
      this.$store.dispatch(this.$LoadShow, false)
      this.$Toast(message || '盖章失败，请重试!')
      if (flag) {
        //盖章失败请求接口
        this.$sealps('/api/doc/sign/qr/signerr?requestId=' + this.requestId + '&token=' + this.token, {},
          this.appCode).then(res => {
            if (!res.success) {
              this.$Toast(res.message || '盖章状态更新失败!')
            }
          }).catch(err => {
            this.$Toast(err.message || '盖章状态更新失败!')
            console.log('signerr', err)
          })
      }
      setTimeout(() => {
        closeCurrentPage(0)
      }, 1000)
    },
    //扫码签获取印章文件hash值
    getSignFileHash(obj) {
      this.$sealps('/api/doc/sign/pkcs?token=' + this.token, JSON.stringify({
        docId: obj.docId,
        segId: obj.segId,
        lockId: obj.lockId,
        fileId: obj.fileId,
        certId: obj.certId,
        signetImgId: obj.signetImgId,
        corpId: obj.corpId,
        staffId: obj.staffId,
        allowSealDate: obj.allowSealDate,
        page: {
          x: obj.page.x,
          y: obj.page.y,
          index: obj.page.index,
          //zoom: obj.page.zoom,
          timeFlag: obj.page.timeFlag,
          reason: obj.page.reason
        },
        //isMobile: true,
      }), {
        appCode: this.appCode,
        verifyToken: this.verifyToken
      }).then((res) => {
        if (res.success && res.data) {
          if (res.data.renewedVerifyToken) {
            this.verifyToken = res.data.renewedVerifyToken
          }
          this.signFlowSealHashSign(obj, res.data, this.$store.state.loginInfo.userName)
        } else {
          this.signResultToast(res.message || res.messageDetail || '盖章获取数据失败，请联系管理员!')
        }
      }).catch((error) => {
        console.log('catch--=', error)
        this.signResultToast('盖章获取数据失败，请重试！')
      })
    },
    //调用证书签署
    signFlowSealHashSign(obj, hashData, userName) {
      getSealHashSign(hashData.signingAttr.certSn,
        hashData.signingPkcs, userName).then(res => {
          if (res) {
            this.signFlowItemFinish(obj, res, hashData)
          } else {
            this.signResultToast('证书签名失败，请检查用户证书！')
          }
        }).catch(err => {
          this.signResultToast('证书签名失败，请检查用户证书！')
        })
    },
    //扫码签提交签署一个印章数据
    signFlowItemFinish(obj, signdata, data) {
      this.$sealps('/api/doc/sign/save?token=' + this.token, JSON.stringify({
        docId: obj.docId,
        segId: obj.segId,
        lockId: data.lockId,
        fileId: data.fileId,
        corpId: obj.corpId,
        staffId: obj.staffId,
        signedData: signdata,
        signingAttr: data.signingAttr,
        qrRequestId: data.qrRequestId,
        isFinished: obj.isFinished,
        clkId: this.clickId,
      }), {
        appCode: this.appCode,
        verifyToken: this.verifyToken
      }).then((res) => {
        if (res.success && res.data) {
          this.retryIndex = 0
          if (res.data.renewedVerifyToken) {
            this.verifyToken = res.data.renewedVerifyToken
          }
          this.index++
          this.getQrNextArgsForRequestId(res.data)
        } else {
          //this.signResultToast(res.message || res.messageDetail || '盖章失败，请联系管理员！')
          if (res.code == 'VE001') {
            if (this.retryIndex >= 5) {
              this.retryIndex = 0
              this.$store.dispatch(this.$LoadShow, false)
              this.showMessageInfoAlert('盖章失败，请继续拖动印章到文件还未盖章处，点击【签署文件】完成盖章!', 0, '关闭')
            } else {
              this.retryIndex++
              this.retryCount++
              obj.lockId = data.lockId
              this.getSignFileHash(obj)
            }
          } else {
            this.signResultToast(res.message || res.messageDetail || '盖章失败，请联系管理员！')
          }
        }
      }).catch((error) => {
        console.log('catch--=', error)
        this.signResultToast('盖章失败，请重试！')
      })
    },
    //扫码签实人、活体认证成功
    scanAuthSucced() {
      this.$store.dispatch(this.$LoadShow, false)
      this.$Toast('认证成功！')
      setTimeout(() => {
        closeCurrentPage(1)
      }, 1000)
    },
    //扫码签实人、活体认证失败
    scanAuthFailed(msg) {
      this.$store.dispatch(this.$LoadShow, false)
      this.$Toast(msg || '认证失败，请重新认证！')
      setTimeout(() => {
        closeCurrentPage(0)
      }, 3000)
    },
    //
    showMessageInfoAlert(message, type, confirmButtonText = '关闭') {
      Dialog.alert({
        title: '提示',
        message: message,
        confirmButtonText: confirmButtonText,
        confirmButtonColor: '#0277FC'
      }).then(() => {
        if (type === 0) {
          this.signResultToast('盖章失败，请重试！')
        }
      });
    },

  },
  mounted() {
    this.init()
  },
  created() {
    window.scanAuthSucced = this.scanAuthSucced
    window.scanAuthFailed = this.scanAuthFailed
  },
  beforeDestroy() {

  },
  destroyed() { }
}
</script>

<style lang="scss" scoped>
@import "../../styles/global.css";

.scancode {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>